(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[187],{

/***/ 89781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ commonlayout_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utilities.js
var utilities = __webpack_require__(66156);
// EXTERNAL MODULE: ./src/hooks/auth.js + 1 modules
var auth = __webpack_require__(39851);
// EXTERNAL MODULE: ./src/components/commonlayout/AccountMenu.js
var AccountMenu = __webpack_require__(72242);
// EXTERNAL MODULE: ./src/constants.js
var constants = __webpack_require__(10288);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/MenuDropdown.js






var MenuDropdown = function MenuDropdown(_ref) {
  var item = _ref.item,
      renderTrigger = _ref.renderTrigger;
  var router = (0,next_router.useRouter)();
  var buttonRef = (0,react.useRef)(null);
  var timeoutDuration = 200;
  var timeout;

  var closePopover = function closePopover() {
    var _buttonRef$current;

    return (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.dispatchEvent(new KeyboardEvent("keydown", {
      key: "Escape",
      bubbles: true,
      cancelable: true
    }));
  };

  var onMouseEnter = function onMouseEnter(open) {
    var _buttonRef$current2;

    clearTimeout(timeout);
    if (open) return;
    return (_buttonRef$current2 = buttonRef.current) === null || _buttonRef$current2 === void 0 ? void 0 : _buttonRef$current2.click();
  };

  var onMouseLeave = function onMouseLeave(open) {
    if (!open) return;
    timeout = setTimeout(function () {
      return closePopover();
    }, timeoutDuration);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover */.J, {
    className: "relative inline-block",
    children: function children(_ref2) {
      var open = _ref2.open;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
          ref: buttonRef,
          onMouseEnter: onMouseEnter.bind(null, open),
          onMouseLeave: onMouseLeave.bind(null, open),
          className: "inline-flex items-center gap-x-1 font-semibold leading-6 text-gray-900 outline-none",
          children: renderTrigger(open)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* Transition */.u, {
          as: react.Fragment,
          enter: "transition ease-out duration-200",
          enterFrom: "opacity-0 translate-y-1",
          enterTo: "opacity-100 translate-y-0",
          leave: "transition ease-in duration-150",
          leaveFrom: "opacity-100 translate-y-0",
          leaveTo: "opacity-0 translate-y-1",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
            className: "absolute left-1/2 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 px-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onMouseEnter: onMouseEnter.bind(null, open),
              onMouseLeave: onMouseLeave.bind(null, open),
              className: "w-screen max-w-sm flex-auto rounded-3xl bg-white p-4 text-sm mt-1 leading-6 shadow-lg ring-1 ring-gray-900/5 overflow-hidden",
              children: item.children.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex gap-x-6 relative rounded-lg p-4 hover:bg-gray-50 ".concat(item.links.includes(router.pathname) ? "bg-gray-50" : ""),
                  children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "rounded-lg p-3 bg-gray-50",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(item.icon, {
                        className: "h-6 w-6 text-gray-40",
                        "aria-hidden": "true"
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                      href: item.href,
                      className: "font-semibold text-gray-900",
                      children: [item.name, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "absolute inset-0"
                      })]
                    }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "mt-1 text-gray-600",
                      children: item.description
                    })]
                  })]
                }, index);
              })
            })
          })
        })]
      });
    }
  });
};
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(65885);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./src/services/slices/otherReducersSlice/index.js
var otherReducersSlice = __webpack_require__(38183);
;// CONCATENATED MODULE: ./src/components/BannerHeader.js
/* provided dependency */ var process = __webpack_require__(34155);










var BannerHeader = function BannerHeader() {
  var cookies = new es6/* default */.Z();
  var dispatch = (0,es/* useDispatch */.I0)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl",
        "aria-hidden": "true",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30",
          style: {
            clipPath: "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl",
        "aria-hidden": "true",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30",
          style: {
            clipPath: "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)"
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: "text-sm leading-6 text-gray-900",
        children: [process.env.NEXT_PUBLIC_TOP_BANNER_TEXT, " ",  true && /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "https://go.tacnique.com/en-in/download-react-candidates-with-interview-insights",
          target: "_blank",
          className: "whitespace-nowrap font-semibold",
          rel: "noreferrer",
          children: ["Download now", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            "aria-hidden": "true",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
              icon: free_solid_svg_icons/* faArrowRight */.eFW,
              className: "flex-shrink-0 h-6 w-6",
              "aria-hidden": "true"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-1 justify-end",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          type: "button",
          className: "-m-3 p-3 focus-visible:outline-offset-[-4px]",
          onClick: function onClick() {
            cookies.set("isBannerHeaderClosed", true, {
              maxAge: 172800,
              //for 2days
              path: "/",
              sameSite: "strict",
              domain: (0,utilities/* getCookieDomain */.yT)()
            });
            dispatch((0,otherReducersSlice/* hideBannerStatus */.Js)(true));
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "sr-only",
            children: "Dismiss"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: free_solid_svg_icons/* faXmark */.g82,
            className: "flex-shrink-0 h-6 w-6",
            "aria-hidden": "true"
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var components_BannerHeader = (BannerHeader);
;// CONCATENATED MODULE: ./src/components/commonlayout/Header.js
/* provided dependency */ var Header_process = __webpack_require__(34155);


















var Header = function Header(_ref) {
  var isEngineer = _ref.isEngineer;
  var router = (0,next_router.useRouter)();

  var _useAuth = (0,auth/* useAuth */.a)({
    middleware: "guest"
  }),
      user = _useAuth.user;

  var _userRole = (0,utilities/* userRole */.xZ)(user),
      userIsCompany = _userRole.userIsCompany,
      userIsEngineer = _userRole.userIsEngineer;

  var _useAuth2 = (0,auth/* useAuth */.a)(),
      logout = _useAuth2.logout;

  var _useSelector = (0,es/* useSelector */.v9)(function (store) {
    return store.other;
  }),
      hideBanner = _useSelector.hideBanner;

  var module = "";

  if (userIsCompany) {
    module = "company";
  }

  if (userIsEngineer) {
    module = "engineer";
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "header",
    children: [Header_process.env.NEXT_PUBLIC_TOP_BANNER_TEXT && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mx-auto",
      children: (0,utilities/* isPublicPage */.wl)(router) && !hideBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(components_BannerHeader, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mx-auto shadow",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative pt-4 pb-4 px-4 sm:px-4 lg:px-24 max-w-8xl mx-auto ",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
            className: "relative z-50 items-center flex justify-between sm:h-10",
            "aria-label": "Global",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center flex-grow flex-shrink-0 lg:flex-grow-0",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between w-full lg:w-auto",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "".concat(module === "company" ? "/".concat(module, "/dashboard") : module === "engineer" ? "/".concat(module, "/profile") : "/"),
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                    "data-test-id": "tacnique-logo",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "sr-only",
                      children: "Tacnique"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: "/logos/tacnique-logo.svg",
                      alt: "Tacnique Logo",
                      width: 142,
                      height: 40,
                      loading: "lazy"
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "-mr-2 flex items-center lg:hidden",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                    className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "sr-only",
                      children: "Open main menu"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                      icon: free_solid_svg_icons/* faBars */.xiG,
                      className: "h-5 w-5",
                      "aria-hidden": "true"
                    })]
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block  lg:ml-12 lg:pr-4 lg:space-x-8",
                children: constants/* homeNavigation.map */.H4.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                    children: item.children ? /*#__PURE__*/(0,jsx_runtime.jsx)(MenuDropdown, {
                      item: item,
                      renderTrigger: function renderTrigger() {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                          onClick: function onClick() {
                            if (item.href) {
                              router.push(item.href);
                            }
                          },
                          className: item.links.includes(router.pathname) ? "font-medium text-primary-700 hover:text-primary-900" : "font-medium text-gray-500 hover:text-gray-900 relative",
                          "data-test-id": "nav-".concat(item.name.replace(" ", "-").toLowerCase()),
                          children: [item.name, /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            className: "ml-2 font-sm ",
                            icon: free_solid_svg_icons/* faChevronDown */.ptq
                          })]
                        }, item.name);
                      }
                    }, index) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: item.href,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        type: "button",
                        className: item.links.includes(router.pathname) ? "font-medium text-primary-700 hover:text-primary-900" : "font-medium text-gray-500 hover:text-gray-900",
                        "data-test-id": "nav-".concat(item.name.replace(" ", "-").toLowerCase()),
                        children: item.name
                      })
                    }, index)
                  }, item.name);
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AccountMenu/* default */.Z, {
              user: user,
              logout: logout,
              size: "large",
              check: false,
              module: module,
              organization: user === null || user === void 0 ? void 0 : user.organization,
              isEngineer: isEngineer,
              userRoles: user === null || user === void 0 ? void 0 : user.roles
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* Transition */.u, {
          as: react.Fragment,
          enter: "duration-150 ease-out",
          enterFrom: "opacity-0 scale-95",
          enterTo: "opacity-100 scale-100",
          leave: "duration-100 ease-in",
          leaveFrom: "opacity-100 scale-100",
          leaveTo: "opacity-0 scale-95",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(popover/* Popover.Panel */.J.Panel, {
            focus: true,
            className: "absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-50",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "px-5 pt-4 flex items-center justify-between",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: "/logos/tacnique-logo.svg",
                    alt: "tacnique-logo",
                    className: "h-8 w-auto",
                    loading: "lazy",
                    width: 142,
                    height: 40
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "-mr-2",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                    className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "sr-only",
                      children: "Close main menu"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                      icon: free_solid_svg_icons/* faXmark */.g82,
                      className: "h-5 w-5",
                      "aria-hidden": "true"
                    })]
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "px-2 pt-2 pb-3 space-y-1",
                children: constants/* homeNavigation.map */.H4.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                    children: item.children ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                        href: item.href,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                          className: item.links.includes(router.pathname) ? "block px-3 py-2 rounded-md text-base font-medium text-primary-700 hover:text-primary-900 hover:bg-primary-50" : "block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50",
                          "data-test-id": "nav-".concat(item.name.replace(" ", "-").toLowerCase()),
                          children: item.name
                        })
                      }, index), item.children.map(function (child, childIndex) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                          href: child.href,
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            className: child.links.includes(router.pathname) ? "block px-3 py-2 rounded-md text-base font-medium text-primary-700 hover:text-primary-900 hover:bg-primary-50" : "block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50",
                            "data-test-id": "nav-".concat(child.name.replace(" ", "-").toLowerCase()),
                            children: child.name
                          }, child.name)
                        }, childIndex);
                      })]
                    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: item.href,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        className: item.links.includes(router.pathname) ? "block px-3 py-2 rounded-md text-base font-medium text-primary-700 hover:text-primary-900 hover:bg-primary-50" : "block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50",
                        "data-test-id": "nav-".concat(item.name.replace(" ", "-").toLowerCase()),
                        children: item.name
                      })
                    }, index)
                  }, item.name);
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AccountMenu/* default */.Z, {
              size: "small",
              module: module,
              user: user,
              check: false,
              logout: logout,
              isEngineer: isEngineer,
              userRoles: user === null || user === void 0 ? void 0 : user.roles
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var commonlayout_Header = (Header);

/***/ }),

/***/ 52026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74865);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_0__);


var useLoader = function useLoader() {
  if ( true && document) {
    nprogress__WEBPACK_IMPORTED_MODULE_0___default().configure({
      showSpinner: false
    });
    return {
      start: function start() {
        return nprogress__WEBPACK_IMPORTED_MODULE_0___default().start();
      },
      done: function done() {
        return nprogress__WEBPACK_IMPORTED_MODULE_0___default().done();
      },
      isActive: Boolean((nprogress__WEBPACK_IMPORTED_MODULE_0___default().status))
    };
  }

  return {
    start: function start() {},
    done: function done() {},
    isActive: false
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useLoader);

/***/ }),

/***/ 74865:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ })

}]);